import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative rounded-2xl overflow-hidden mb-10 md:mb-14 aspect-[21/9]">
          <img
            src="https://readdy.ai/api/search-image?query=Epic%20manga%20battle%20scene%20with%20two%20powerful%20characters%20facing%20off%2C%20dramatic%20energy%20auras%2C%20dark%20atmospheric%20background%20with%20ruins%2C%20warm%20orange%20and%20crimson%20accents%2C%20cinematic%20composition%2C%20high%20detail%20illustration%2C%20professional%20comic%20panel%20style&width=1600&height=700&seq=cta-manga-scene&orientation=landscape"
            alt="全球诡异时代 - 精彩战斗场景"
            title="全球诡异时代漫画 - 叮当漫画网"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-100 leading-snug">
          准备好进入<span className="text-foreground-400 font-light italic">诡异世界</span>了吗？
        </h2>
        <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
          数千部精彩漫画等你来探索，全部免费阅读，立刻加入叮当漫画网
        </p>

        <Link
          to="/category"
          className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-foreground-100 hover:bg-foreground-200 text-background-50 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
        >
          探索全部漫画
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}